import fetch from '../utils/fetch';
import { cashierUrl } from 'endpoints';
import CashierSDK from '@nackle/cashier-sdk';

export default new CashierSDK( cashierUrl, fetch, undefined );
